import Icon from "assets/icons";
import OpenLinkInNewTab from "shared/form/core/link";
import { ParticipantInfo } from "../../types";
import React from "react";
import { getNameInitials } from "shared/utils";
import useImageURLCheck from "shared/hooks/useImageUrlCheck";

export default function ParticipantInfoCard(props: {
  profilePictureLocation?: string;
  participantInfo?: ParticipantInfo;
}) {
  const hasValidImgURL = useImageURLCheck({
    imageLocation: props.profilePictureLocation
  });
  const nameInitials = React.useMemo(
    () => getNameInitials(`${props.participantInfo?.firstName} ${props.participantInfo?.lastName}`) || "",
    [props.participantInfo?.firstName, props.participantInfo?.lastName]
  );
  if (!props.participantInfo) {
    return null;
  }
  return (
    <div className="view_profile">
      {props.profilePictureLocation && hasValidImgURL ? (
        <div className="view_profile_img">
          <img
            src={props.profilePictureLocation}
            alt={`${props.participantInfo?.firstName} ${props.participantInfo?.lastName}`}
          />
        </div>
      ) : (
        <div className="view_profile_initial">
          <span>{nameInitials}</span>
        </div>
      )}
      <div className="view_profile_content">
        <span className="name">
          {`${props.participantInfo?.firstName} ${props.participantInfo?.lastName}`}
          {props.participantInfo?.linkedin && (
            <OpenLinkInNewTab
              url={props.participantInfo?.linkedin}
              title={props.participantInfo?.linkedin}
              className="participant_details_actions_linkedin">
              <Icon.Linkedin />
            </OpenLinkInNewTab>
          )}
        </span>
        <ul className="list-unstyled view_profile_content_description">
          {props.participantInfo?.jobTitle && (
            <li>
              <span className="job_title">{`${props.participantInfo?.jobTitle}`}</span>
            </li>
          )}
          {props.participantInfo?.organizationName && (
            <li>
              {props.participantInfo?.organizationUrl ? (
                <OpenLinkInNewTab
                  url={props.participantInfo?.organizationUrl}
                  title={props.participantInfo?.organizationUrl}
                  className="participant_details_actions_linkedin org_name">
                  {props.participantInfo?.organizationName}
                </OpenLinkInNewTab>
              ) : (
                <span className="org_name_text"> {props.participantInfo?.organizationName}</span>
              )}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}
